document.addEventListener("click", (event) => {
	const link = event.target.closest("a[href^='#']");
	if (!link) {
		return;
	}

	const targetId = link.getAttribute("href");
	const target = document.querySelector(targetId);

	if (!target) {
		return;
	}

	event.preventDefault();
	target.scrollIntoView({ behavior: "smooth", block: "start" });
});

const contactForm = document.querySelector(".contact-form");

if (contactForm) {
	contactForm.addEventListener("submit", (event) => {
		event.preventDefault();
	});
}

const siteData = window.SITE_DATA;

function applySiteData() {
	if (!siteData) {
		return;
	}

	const pageTitle = document.body ? document.body.dataset.pageTitle : "";
	if (pageTitle && siteData.firmNameText) {
		const separator = siteData.titleSeparator || " | ";
		document.title = `${pageTitle}${separator}${siteData.firmNameText}`;
	}

	document.querySelectorAll("[data-text]").forEach((element) => {
		const key = element.dataset.text;
		if (siteData[key] !== undefined) {
			element.textContent = siteData[key];
		}
	});

	document.querySelectorAll("[data-html]").forEach((element) => {
		const key = element.dataset.html;
		if (siteData[key] !== undefined) {
			element.innerHTML = siteData[key];
		}
	});

	document.querySelectorAll("[data-tel]").forEach((element) => {
		const key = element.dataset.tel;
		const phoneValue = key ? siteData[key] : siteData.phone;
		if (phoneValue) {
			element.setAttribute("href", `tel:${phoneValue}`);
		}
	});

	document.querySelectorAll("[data-mail]").forEach((element) => {
		const key = element.dataset.mail;
		const emailValue = key ? siteData[key] : siteData.email;
		if (emailValue) {
			element.setAttribute("href", `mailto:${emailValue}`);
		}
	});
}

window.__onPartialsLoaded = applySiteData;

if (window.__partialsLoaded) {
	applySiteData();
}

document.addEventListener("partials:loaded", applySiteData);
applySiteData();

document.body.addEventListener("click", (event) => {
	const toggle = event.target.closest(".mobile-toggle");
	if (toggle) {
		const isOpen = document.body.classList.toggle("nav-active");
		toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
		return;
	}

	const navLink = event.target.closest(".nav a");
	if (navLink) {
		document.body.classList.remove("nav-active");
		const toggleButton = document.querySelector(".mobile-toggle");
		if (toggleButton) {
			toggleButton.setAttribute("aria-expanded", "false");
		}
		return;
	}

	if (document.body.classList.contains("nav-active")) {
		const isNavClick = event.target.closest(".nav");
		const isHeaderClick = event.target.closest(".site-header");
		if (!isNavClick && !isHeaderClick) {
			document.body.classList.remove("nav-active");
			const toggleButton = document.querySelector(".mobile-toggle");
			if (toggleButton) {
				toggleButton.setAttribute("aria-expanded", "false");
			}
		}
	}
});

let lastScrollY = window.scrollY;

window.addEventListener("scroll", () => {
	if (window.innerWidth > 900) {
		document.body.classList.remove("header-hidden");
		lastScrollY = window.scrollY;
		return;
	}

	const currentScrollY = window.scrollY;
	const scrollingDown = currentScrollY > lastScrollY;

	if (currentScrollY > 80 && scrollingDown && !document.body.classList.contains("nav-active")) {
		document.body.classList.add("header-hidden");
	} else {
		document.body.classList.remove("header-hidden");
	}

	lastScrollY = currentScrollY;
});
